// extracted by mini-css-extract-plugin
module.exports = {"appName":"MobileAppChannelCheckBox_appName__Vomt5"};